export default __webpack_public_path__ + "static/media/BASE_TECNOLOGIA_RT_160_4V_BANNER_01.b583f0d5.jpg";